module.exports = __webpack_public_path__ + "portal-static/img/data-all.2842a755.png";